<template>
  <div aria-live="assertive"
       :style="'padding-top: ' + topPadding + 'px;'"
       class="pointer-events-none fixed inset-0 flex items-end px-4 sm:items-start">
<!--    Note: The following classes were on the original Tailwind UI transition, but were causing errors. -->
<!--      They are left here mainly for reference in the future in case a better engineer wants to fix this.-->

<!--    enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"-->
<!--    enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"-->
<!--    leave-active-class="transition ease-in duration-100"-->
<!--    leave-from-class="opacity-100"-->
<!--    leave-to-class="opacity-0"-->
    <transition-group
      class="flex w-full flex-col items-center space-y-4 sm:items-end"
      tag="div"
      enter-active-class="transform ease-out duration-300 transition"
      leave-active-class="transition ease-in duration-100"
    >
      <div :key="notification.id + 'template'"
           v-for="(notification, index) in allNotifyObjectsNotInHideIndex"
           class="pointer-events-auto z-50 flex w-full max-w-md divide-x divide-gray-200 rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5">
        <div class="basis-3/4 flex w-0 flex-1 items-center p-4">
          <div class="w-full">
            <p class="text-sm font-lg text-gray-900">
              {{  notification.data.title }}
            </p>
            <p v-html="notification.data.message" class="mt-1 text-sm font-medium text-gray-500">
            </p>
          </div>
        </div>
        <div class="basis-1/4 flex">
          <div v-if="notification.data.action_text !== null" class="flex flex-col w-full divide-y divide-gray-200">
            <div class="flex h-0 flex-1">
              <button
                type="button"
                @click="openNotification(notification)"
                class="flex w-full items-center justify-center rounded-none rounded-tr-lg border border-transparent px-4 py-3 text-sm font-medium text-blue-600 hover:text-blue-500 focus:z-10 focus:outline-none focus:ring-2 focus:ring-blue-500">
                {{  notification.data.action_text }}
              </button>
            </div>
            <div class="flex h-0 flex-1 w-full ">
              <button type="button"
                      @click="dismissNotification(notification)"
                      class="flex w-full items-center justify-center rounded-none rounded-br-lg border border-transparent px-4 py-3 text-sm font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500">
                {{  notification.data.dismiss_text }}
              </button>
            </div>
          </div>
          <div v-else
               class="flex w-full border-gray-200">
            <button type="button"
                    @click="dismissNotification(notification)"
                    class="flex w-full items-center justify-center rounded-none rounded-r-lg border border-transparent p-4 text-sm font-medium text-blue-600 hover:text-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500">
              {{  notification.data.dismiss_text }}
            </button>
          </div>
        </div>
      </div>

    </transition-group>
  </div>
</template>

<script>
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import axios from "axios";
import _ from "lodash";

export default {
  name: "notifications",
  components: {},
  mixins: [SonicuCoreMixin],
  data() {
    return {
      show: true,
      notifyObjects: [],
      hideIndex: [],
      goalTextViewLink: 'RG9Z7FGU',
      goalTextDismissLink: 'H3AWIU15',
    }
  },
  props: {
    topPadding: {
      type: Number,
      default: 96,
    }
  },
  mounted() {
    axios.get(this.company.buildApiInternalRoute('notifications'),).then(response => {
      let data = response.data.data;
      this.notifyObjects = data;
    }).catch(error => {
      console.log(error)
    }).then(() => {
    })
  },
  methods: {
    openNotification(notification) {
      this.hideIndex.push(notification.id);
      window.open(notification.data.action_url, '_blank');
      axios.delete(this.company.buildApiInternalRoute('notifications/' + notification.id + '/'), )
        .then(response => {
          this.fathomGoalTrack(this.goalTextViewLink)
        }).catch(error => {
        console.log(error)
      }).then(() => {
      })
    },
    dismissNotification(notification) {
      this.hideIndex.push(notification.id);
      axios.delete(this.company.buildApiInternalRoute('notifications/' + notification.id + '/'), )
        .then(response => {
          this.fathomGoalTrack(this.goalTextDismissLink)
      }).catch(error => {
        console.log(error)
      }).then(() => {
      })
    },
    fathomGoalTrack(goalText) {
      if (window.fathomLoaded && goalText > 0) {
        window.fathom.trackGoal(goalText, 0);
      }
    }
  },
  computed: {
    allNotifyObjectsNotInHideIndex() {
      return this.notifyObjects.filter(notification => {
        return !this.hideIndex.includes(notification.id);
      });
    }
  }
}
</script>